{
  "button_add_more_images": [
    {
      "type": 0,
      "value": "Přidat další fotky"
    }
  ],
  "button_approve": [
    {
      "type": 0,
      "value": "Schválit"
    }
  ],
  "button_back": [
    {
      "type": 0,
      "value": "Zpět"
    }
  ],
  "button_back_to_cart": [
    {
      "type": 0,
      "value": "Galerie"
    }
  ],
  "button_back_to_login": [
    {
      "type": 0,
      "value": "Zpět na přihlášení"
    }
  ],
  "button_bill_to_room": [
    {
      "type": 0,
      "value": "Účtovat na pokoj"
    }
  ],
  "button_buy_more": [
    {
      "type": 0,
      "value": "Koupit další"
    }
  ],
  "button_cancel": [
    {
      "type": 0,
      "value": "Zrušit"
    }
  ],
  "button_close": [
    {
      "type": 0,
      "value": "Zavřít"
    }
  ],
  "button_complete_purchase": [
    {
      "type": 0,
      "value": "Dokončit nákup"
    }
  ],
  "button_continue": [
    {
      "type": 0,
      "value": "Pokračovat"
    }
  ],
  "button_credit_or_debit_card": [
    {
      "type": 0,
      "value": "Platební karta"
    }
  ],
  "button_customer_login": [
    {
      "type": 0,
      "value": "Zpět na přihlášení zákazníka"
    }
  ],
  "button_done": [
    {
      "type": 0,
      "value": "HOTOVO"
    }
  ],
  "button_download": [
    {
      "type": 0,
      "value": "Stáhnout"
    }
  ],
  "button_edit_order": [
    {
      "type": 0,
      "value": "Upravit objednávku"
    }
  ],
  "button_enter": [
    {
      "type": 0,
      "value": "Vstoupit"
    }
  ],
  "button_forgot": [
    {
      "type": 0,
      "value": "Zapomenuto"
    }
  ],
  "button_got_it": [
    {
      "type": 0,
      "value": "Rozumím"
    }
  ],
  "button_image_view_next": [
    {
      "type": 0,
      "value": "Další (šipka vpravo)"
    }
  ],
  "button_image_view_previous": [
    {
      "type": 0,
      "value": "Předchozí (šipka vlevo)"
    }
  ],
  "button_image_view_zoom": [
    {
      "type": 0,
      "value": "Zvětšit nebo zmenšit"
    }
  ],
  "button_log_out": [
    {
      "type": 0,
      "value": "Odhlásit se"
    }
  ],
  "button_login": [
    {
      "type": 0,
      "value": "Přihlásit se"
    }
  ],
  "button_lookup_gallery": [
    {
      "type": 0,
      "value": "Vyhledat v galerii"
    }
  ],
  "button_more_images": [
    {
      "type": 0,
      "value": "Další fotky"
    }
  ],
  "button_new_order": [
    {
      "type": 0,
      "value": "Nová objednávka"
    }
  ],
  "button_ok": [
    {
      "type": 0,
      "value": "OK"
    }
  ],
  "button_price_guide": [
    {
      "type": 0,
      "value": "Průvodce cenami"
    }
  ],
  "button_print": [
    {
      "type": 0,
      "value": "Tisk"
    }
  ],
  "button_process": [
    {
      "type": 0,
      "value": "Zpracovat"
    }
  ],
  "button_purchase": [
    {
      "type": 0,
      "value": "Koupit"
    }
  ],
  "button_refresh": [
    {
      "type": 0,
      "value": "Obnovit"
    }
  ],
  "button_remove": [
    {
      "type": 0,
      "value": "Odebrat"
    }
  ],
  "button_remove_prints": [
    {
      "type": 0,
      "value": "Odstranit výtisky"
    }
  ],
  "button_review_and_purchase": [
    {
      "type": 0,
      "value": "Zkontrolovat a koupit"
    }
  ],
  "button_review_cart": [
    {
      "type": 0,
      "value": "Košík"
    }
  ],
  "button_select": [
    {
      "type": 0,
      "value": "Vybrat"
    }
  ],
  "button_selected_print_sizes": [
    {
      "type": 0,
      "value": "Vybrané velikosti tisku ("
    },
    {
      "type": 1,
      "value": "quantity"
    },
    {
      "type": 0,
      "value": ")"
    }
  ],
  "button_send_link": [
    {
      "type": 0,
      "value": "Poslat odkaz"
    }
  ],
  "button_send_links": [
    {
      "type": 0,
      "value": "Poslat odkazy"
    }
  ],
  "button_share": [
    {
      "type": 0,
      "value": "Sdílet"
    }
  ],
  "button_stay": [
    {
      "type": 0,
      "value": "Zůstat"
    }
  ],
  "button_stripe_reader": [
    {
      "type": 0,
      "value": "Stripe Reader"
    }
  ],
  "button_tilby": [
    {
      "type": 0,
      "value": "Tilby"
    }
  ],
  "button_toggle_access_codes": [
    {
      "type": 0,
      "value": "Zobrazit/skrýt přístupové kódy"
    }
  ],
  "button_view_gallery": [
    {
      "type": 0,
      "value": "Zobrazit galerii"
    }
  ],
  "button_view_my_gallery": [
    {
      "type": 0,
      "value": "Zobrazit moji galerii"
    }
  ],
  "button_view_receipt": [
    {
      "type": 0,
      "value": "Zobrazit účtenku"
    }
  ],
  "cart_add_image_no_cost": [
    {
      "type": 0,
      "value": "Můžete přidat další fotky zdarma"
    }
  ],
  "cart_apply_coupon": [
    {
      "type": 0,
      "value": "Uplatnit"
    }
  ],
  "cart_buy_all_at_price": [
    {
      "type": 0,
      "value": "Cena za nákup všeho je "
    },
    {
      "type": 1,
      "value": "amount"
    }
  ],
  "cart_buy_all_discount_description": [
    {
      "type": 0,
      "value": "Koupit všechny obrázky za "
    },
    {
      "type": 1,
      "value": "price"
    }
  ],
  "cart_buy_all_discount_label": [
    {
      "type": 1,
      "value": "price"
    },
    {
      "type": 0,
      "value": " pro všechny"
    }
  ],
  "cart_cart_details": [
    {
      "type": 0,
      "value": "Podrobnosti o košíku"
    }
  ],
  "cart_cart_total": [
    {
      "type": 0,
      "value": "Celková cena košíku"
    }
  ],
  "cart_checkout": [
    {
      "type": 0,
      "value": "Pokladna"
    }
  ],
  "cart_coupon_code": [
    {
      "type": 0,
      "value": "Kód kupónu"
    }
  ],
  "cart_coupon_code_instructions": [
    {
      "type": 0,
      "value": "Zadejte kód kupónu, který chcete uplatnit na objednávku."
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "Kliknutím na tlačítko Pokračovat přejdete k dokončení nákupu."
    }
  ],
  "cart_credit_debit_card": [
    {
      "type": 0,
      "value": "Platební karta"
    }
  ],
  "cart_digital_image": [
    {
      "type": 0,
      "value": "Digitální snímky"
    }
  ],
  "cart_digitals": [
    {
      "offset": 0,
      "options": {
        "few": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " digitální snímky"
            }
          ]
        },
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " digitální snímek"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " digitálních snímků"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "quantity"
    }
  ],
  "cart_digitals_and_prints": [
    {
      "offset": 0,
      "options": {
        "few": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " digitální snímky"
            }
          ]
        },
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " digitální snímek"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " digitálních snímků"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "digitals"
    },
    {
      "type": 0,
      "value": " & "
    },
    {
      "offset": 0,
      "options": {
        "few": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " výtisky"
            }
          ]
        },
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " výtisk"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " výtisků"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "quantity"
    }
  ],
  "cart_discount_label": [
    {
      "type": 0,
      "value": "Nakupte víc fotek a získejte slevu"
    }
  ],
  "cart_image_free_of_charge": [
    {
      "type": 0,
      "value": "Tuto fotku "
    },
    {
      "type": 1,
      "value": "imageDesc"
    },
    {
      "type": 0,
      "value": " vám poskytneme zdarma."
    }
  ],
  "cart_link_to_gallery": [
    {
      "type": 0,
      "value": "Odkaz na vaši galerii byl odeslán na adresu "
    },
    {
      "type": 1,
      "value": "email"
    }
  ],
  "cart_no_photos_available": [
    {
      "type": 0,
      "value": "Momentálně nejsou k dispozici žádné fotky. Pokud vás právě fotografovali, brzy se zde objeví, proto se vraťte později. Pokud ještě nemáte pořízené fotky, obraťte se na fotografa."
    }
  ],
  "cart_no_selected_image": [
    {
      "type": 0,
      "value": "Před dokončením objednávky vyberte fotky, které si chcete koupit"
    }
  ],
  "cart_on_date": [
    {
      "type": 0,
      "value": "v "
    },
    {
      "type": 1,
      "value": "date"
    }
  ],
  "cart_packages_discount_description": [
    {
      "type": 0,
      "value": "Získejte "
    },
    {
      "offset": 0,
      "options": {
        "few": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " obrázky"
            }
          ]
        },
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " obrázek"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " obrázků"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "quantity"
    },
    {
      "type": 0,
      "value": " pro "
    },
    {
      "type": 1,
      "value": "price"
    }
  ],
  "cart_packages_discount_description_all": [
    {
      "type": 0,
      "value": "Získejte všechny obrázky pro "
    },
    {
      "type": 1,
      "value": "price"
    }
  ],
  "cart_packages_discount_description_range": [
    {
      "type": 0,
      "value": "Získejte "
    },
    {
      "type": 1,
      "value": "minimum"
    },
    {
      "type": 0,
      "value": "-"
    },
    {
      "type": 1,
      "value": "maximum"
    },
    {
      "type": 0,
      "value": " fotografie za "
    },
    {
      "type": 1,
      "value": "price"
    }
  ],
  "cart_packages_discount_label": [
    {
      "type": 1,
      "value": "quantity"
    },
    {
      "type": 0,
      "value": " pro "
    },
    {
      "type": 1,
      "value": "price"
    }
  ],
  "cart_packages_discount_label_range": [
    {
      "type": 1,
      "value": "minimum"
    },
    {
      "type": 0,
      "value": "-"
    },
    {
      "type": 1,
      "value": "maximum"
    },
    {
      "type": 0,
      "value": " pro "
    },
    {
      "type": 1,
      "value": "price"
    }
  ],
  "cart_price_guide": [
    {
      "type": 0,
      "value": "Průvodce cenami"
    }
  ],
  "cart_price_guide_notes": [
    {
      "type": 0,
      "value": "Informace o cenách najdete v Průvodci cenami"
    }
  ],
  "cart_prints": [
    {
      "offset": 0,
      "options": {
        "few": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " výtisky"
            }
          ]
        },
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " výtisk"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " výtisků"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "quantity"
    }
  ],
  "cart_purchase": [
    {
      "type": 0,
      "value": "Koupit"
    }
  ],
  "cart_purchase_unavailable": [
    {
      "type": 0,
      "value": "Nákup z mobilního zařízení není k dispozici. Fotky si můžete prohlédnout v kiosku na místě."
    }
  ],
  "cart_purchased": [
    {
      "type": 0,
      "value": "Zakoupené"
    }
  ],
  "cart_purchasing": [
    {
      "type": 0,
      "value": "Nakupujete"
    }
  ],
  "cart_sorry_charge_problem": [
    {
      "type": 0,
      "value": "Omlouváme se, ale vyskytl se problém, který znemožnil provedení této platby. Zkuste to znovu, a pokud problém přetrvává, kontaktujte nás."
    }
  ],
  "cart_standard_price": [
    {
      "type": 0,
      "value": "Standardní cena je "
    },
    {
      "type": 1,
      "value": "amount"
    },
    {
      "type": 0,
      "value": " každá"
    }
  ],
  "cart_thank_you_purchase": [
    {
      "type": 0,
      "value": "Děkujeme vám za nákup!"
    }
  ],
  "cart_total": [
    {
      "type": 0,
      "value": "Celkem"
    }
  ],
  "cart_unlock_all": [
    {
      "type": 0,
      "value": "Všechny digitální snímky"
    }
  ],
  "cart_unlock_all_prints": [
    {
      "type": 0,
      "value": "Všechny digitální snímky a výtisky"
    }
  ],
  "cart_unpurchased": [
    {
      "type": 0,
      "value": "Nezakoupené"
    }
  ],
  "cart_view_photos": [
    {
      "type": 0,
      "value": "Zobrazit fotky"
    }
  ],
  "cart_volume_discount_description": [
    {
      "type": 0,
      "value": "Nakupte "
    },
    {
      "offset": 0,
      "options": {
        "few": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " obrázky"
            }
          ]
        },
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " obrázek"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " obrázků"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "quantity"
    },
    {
      "type": 0,
      "value": " a získejte slevu "
    },
    {
      "type": 1,
      "value": "percent"
    },
    {
      "type": 0,
      "value": " %"
    }
  ],
  "cart_volume_discount_label": [
    {
      "type": 1,
      "value": "percent"
    },
    {
      "type": 0,
      "value": " % sleva "
    },
    {
      "type": 1,
      "value": "quantity"
    },
    {
      "type": 0,
      "value": " nebo více"
    }
  ],
  "consumer_agreement": [
    {
      "type": 0,
      "value": "Používáním Capturelife souhlasíte s našimi"
    }
  ],
  "consumer_confirm_password": [
    {
      "type": 0,
      "value": "Zadejte a potvrďte své heslo."
    }
  ],
  "consumer_confirm_your_password": [
    {
      "type": 0,
      "value": "Potvrzení hesla"
    }
  ],
  "consumer_contact_us": [
    {
      "type": 0,
      "value": "Kontaktujte nás"
    }
  ],
  "consumer_email_or_phone": [
    {
      "type": 0,
      "value": "E-mail nebo telefon"
    }
  ],
  "consumer_email_or_phone_long": [
    {
      "type": 0,
      "value": "E-mailová adresa nebo telefonní číslo"
    }
  ],
  "consumer_email_placeholder": [
    {
      "type": 0,
      "value": "E-mail"
    }
  ],
  "consumer_enter_email": [
    {
      "type": 0,
      "value": "Zadejte e-mailovou adresu."
    }
  ],
  "consumer_enter_password": [
    {
      "type": 0,
      "value": "Zadejte heslo."
    }
  ],
  "consumer_enter_valid_email_phone": [
    {
      "type": 0,
      "value": "Zadejte platnou e-mailovou adresu nebo telefonní číslo."
    }
  ],
  "consumer_footer_text": [
    {
      "type": 0,
      "value": "KOUZELNICKÝ SVĚT a všechny související ochranné známky, znaky, jména a odkazy jsou © & ™ Warner Bros. Entertainment Inc. Publishing Rights © JKR. (s22)"
    }
  ],
  "consumer_forgot_password": [
    {
      "type": 0,
      "value": "Pokud chcete obnovit heslo, zadejte e-mailovou adresu nebo telefonní číslo"
    }
  ],
  "consumer_forgot_your_password": [
    {
      "type": 0,
      "value": "Zapomněli jste heslo?"
    }
  ],
  "consumer_image_view_print_store": [
    {
      "type": 0,
      "value": "Copycentrum"
    }
  ],
  "consumer_item_generate_qr_code": [
    {
      "type": 0,
      "value": "Vygenerovat QR kód"
    }
  ],
  "consumer_link_expired": [
    {
      "type": 0,
      "value": "Omlouváme se, ale tomuto odkazu vypršela platnost. Zadejte svůj email nebo telefonní číslo, a my vám pošleme nový."
    }
  ],
  "consumer_logging_in": [
    {
      "type": 0,
      "value": "Přihlašování…"
    }
  ],
  "consumer_login_message": [
    {
      "type": 0,
      "value": "Vraťme se zpět k pořízení těchto okamžiků!"
    }
  ],
  "consumer_missing_something_error": [
    {
      "type": 0,
      "value": "Jejda, vypadá to, že vám něco chybí."
    }
  ],
  "consumer_my_personal_data": [
    {
      "type": 0,
      "value": "Moje osobní údaje"
    }
  ],
  "consumer_nav_add_photos": [
    {
      "type": 0,
      "value": "Přidat fotky"
    }
  ],
  "consumer_nav_add_photos_mobile": [
    {
      "type": 0,
      "value": "Přidat"
    }
  ],
  "consumer_nav_back": [
    {
      "type": 0,
      "value": "Zpět"
    }
  ],
  "consumer_nav_download": [
    {
      "type": 0,
      "value": "Stáhnout"
    }
  ],
  "consumer_nav_home": [
    {
      "type": 0,
      "value": "Domů"
    }
  ],
  "consumer_nav_logout": [
    {
      "type": 0,
      "value": "Odhlásit se"
    }
  ],
  "consumer_nav_news": [
    {
      "type": 0,
      "value": "Novinky"
    }
  ],
  "consumer_nav_print_store": [
    {
      "type": 0,
      "value": "Copycentrum"
    }
  ],
  "consumer_nav_profile": [
    {
      "type": 0,
      "value": "Profil"
    }
  ],
  "consumer_nav_refresh": [
    {
      "type": 0,
      "value": "Obnovit"
    }
  ],
  "consumer_nav_share": [
    {
      "type": 0,
      "value": "Sdílet"
    }
  ],
  "consumer_password_alteast_length": [
    {
      "type": 0,
      "value": "Vaše heslo musí obsahovat alespoň "
    },
    {
      "type": 1,
      "value": "count"
    },
    {
      "type": 0,
      "value": " znaků."
    }
  ],
  "consumer_password_placeholder": [
    {
      "type": 0,
      "value": "Heslo"
    }
  ],
  "consumer_passwords_dont_match": [
    {
      "type": 0,
      "value": "Vaše heslo a potvrzení hesla se neshodují."
    }
  ],
  "consumer_qr_text": [
    {
      "type": 0,
      "value": "Udělejte si snímek QR kódu nebo klikněte na tlačítko Stáhnout níže"
    }
  ],
  "consumer_reset_password": [
    {
      "type": 0,
      "value": "Obnovit heslo"
    }
  ],
  "consumer_resetting_password": [
    {
      "type": 0,
      "value": "Obnovuji heslo…"
    }
  ],
  "consumer_retake_photo_button": [
    {
      "type": 0,
      "value": "Vyfotit se znovu"
    }
  ],
  "consumer_search_photo_button": [
    {
      "type": 0,
      "value": "Vyhledat fotky"
    }
  ],
  "consumer_select_all": [
    {
      "type": 0,
      "value": "Vybrat vše"
    }
  ],
  "consumer_selfie_button": [
    {
      "type": 0,
      "value": "Vybrat selfie"
    }
  ],
  "consumer_selfie_instructions": [
    {
      "type": 0,
      "value": "Začněte nahráním selfie"
    }
  ],
  "consumer_selfie_upload_complete": [
    {
      "type": 0,
      "value": "Selfie bylo úspěšně nahráno"
    }
  ],
  "consumer_selfie_upload_failed": [
    {
      "type": 0,
      "value": "Došlo k chybě. Zkuste to prosím znovu."
    }
  ],
  "consumer_selfie_upload_in_progress": [
    {
      "type": 0,
      "value": "Probíhá nahrávání"
    }
  ],
  "consumer_share_dialog_notes": [
    {
      "type": 0,
      "value": "Fotku můžete stáhnout nebo sdílet dlouhým klepnutím na ni – zobrazí se vám možnosti sdílení vašeho zařízení."
    }
  ],
  "consumer_store_title": [
    {
      "type": 0,
      "value": "Internetový obchod"
    }
  ],
  "consumer_take_photo_button": [
    {
      "type": 0,
      "value": "Vyfotit se"
    }
  ],
  "consumer_terms_of_use": [
    {
      "type": 0,
      "value": "Podmínky použití"
    }
  ],
  "consumer_update_email": [
    {
      "type": 0,
      "value": "Zadejte e-mail a heslo, které chcete použít."
    }
  ],
  "consumer_update_password": [
    {
      "type": 0,
      "value": "Aktualizovat heslo"
    }
  ],
  "consumer_update_your_password": [
    {
      "type": 0,
      "value": "Aktualizujte své heslo"
    }
  ],
  "consumer_updating_password": [
    {
      "type": 0,
      "value": "Aktualizuji heslo…"
    }
  ],
  "consumer_welcome_back": [
    {
      "type": 0,
      "value": "Vítejte Zpět!"
    }
  ],
  "error_coupon_already_used": [
    {
      "type": 0,
      "value": "Slevový kód nelze uplatnit. Tento slevový kód již byl pro váš účet použit."
    }
  ],
  "error_coupon_minimum": [
    {
      "type": 0,
      "value": "Slevový kód nelze uplatnit. Celková částka nákupu je nižší než požadovaná minimální částka."
    }
  ],
  "error_coupon_not_found": [
    {
      "type": 0,
      "value": "Slevový kód nebyl nalezen"
    }
  ],
  "error_email_invalid": [
    {
      "type": 0,
      "value": "Zadejte skutečnou e-mailovou adresu."
    }
  ],
  "error_email_required": [
    {
      "type": 0,
      "value": "Zadejte e-mailovou adresu."
    }
  ],
  "error_fields_required": [
    {
      "type": 0,
      "value": "Vyplňte níže uvedená pole."
    }
  ],
  "error_reservation_not_found": [
    {
      "type": 0,
      "value": "Rezervace nebyla nalezena."
    }
  ],
  "error_scan_band": [
    {
      "type": 0,
      "value": "Na tomto účtu nejsou žádné fotografie. Naskenujte náramek, který jste použili ve fotokoutku"
    }
  ],
  "error_see_attendant": [
    {
      "type": 0,
      "value": "Na tomto účtu nejsou žádné fotografie. Požádejte o pomoc fotografa nebo asistenta"
    }
  ],
  "form_label_credit_or_debit_card": [
    {
      "type": 0,
      "value": "Platební karta"
    }
  ],
  "form_label_customers_name": [
    {
      "type": 0,
      "value": "Jméno zákazníka"
    }
  ],
  "form_label_email": [
    {
      "type": 0,
      "value": "E-mail"
    }
  ],
  "form_label_email_address": [
    {
      "type": 0,
      "value": "E-mailová adresa"
    }
  ],
  "form_label_last_name": [
    {
      "type": 0,
      "value": "Příjmení"
    }
  ],
  "form_label_password": [
    {
      "type": 0,
      "value": "Heslo"
    }
  ],
  "form_label_pin": [
    {
      "type": 0,
      "value": "PIN"
    }
  ],
  "form_label_price": [
    {
      "type": 0,
      "value": "Cena (v "
    },
    {
      "type": 1,
      "value": "currency"
    },
    {
      "type": 0,
      "value": ")"
    }
  ],
  "form_label_room_number": [
    {
      "type": 0,
      "value": "Číslo pokoje"
    }
  ],
  "form_label_secret_code": [
    {
      "type": 0,
      "value": "Tajný kód"
    }
  ],
  "form_label_select_all": [
    {
      "type": 0,
      "value": "Vybrat vše"
    }
  ],
  "form_label_unlock_all": [
    {
      "type": 0,
      "value": "Odemknout všechny fotky"
    }
  ],
  "hpx_macao_disclaimer": [
    {
      "type": 0,
      "value": "By using any of the photo shooting props at The Londoner Macao (“Harry Potter – The Exhibition”) you acknowledge and agree that the use of Harry Potter – The Exhibition involves the collection of photographic images of the users (“Photographs” or “Images” and “Users”, respectively)."
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "凡使用澳門倫敦人（「哈利波特－展覽」）的任何拍攝道具，即表示閣下知悉並同意使用「哈利波特－展覽」涉及收集使用者的攝影圖像（分別為“照片”或“圖像”及“使用者”）。"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "凡使用澳门伦敦人（「哈利波特－展览」）的任何拍摄道具，即表示阁下知悉并同意使用「哈利波特－展览」涉及收集使用者的摄影图像（分别为“照片”或“图像” 及“使用者”）。"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "You further acknowledge and agree that HPX Macau Limited and its affiliated entities (“the Company”) have engaged a third-party service provider to provide photographic imaging and services solutions for Harry Potter - The Exhibition (“Service Provider”) with servers located in the United States of America (“USA”), in a jurisdiction with different laws and protections than the ones of the Macau Special Administrative Region (“MSAR”)."
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "閣下亦知悉並同意HPX 澳門有限公司及其附屬實體（「本公司」）已聘請第三方服務提供者為《哈利波特- 展覽》提供攝影圖像和服務方案（「服務提供者」），其伺服器位於美利堅合眾國（「美國」），該司法管轄的法律和保護與澳門特別行政區（「澳門特別行政區」）是有所不同。"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "阁下亦知悉并同意HPX 澳门有限公司及其附属实体（「本公司」）已聘请第三方服务提供者为《哈利波特- 展览》提供摄影圖像和服务方案（「服务提供者」），其伺服器位于美利坚合众国（「美国」），该司法管辖的法律和保护与澳门特别行政区（「澳门特别行政区」）是有所不同。"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "You understand that the Images are collected so that Users may purchase their photographs in loco and are kept for the duration of the event, until January 5th, 2025, in servers in the USA, after which they are automatically deleted. The Company and the Service Provider take appropriate safety measures to help safeguard the Photographs and Images collected from any unauthorized access and disclosure and only authorized employees of both the Company or the Service Provider have access to them, exclusively for permitted business functions and by using a valid user name and password.  While the Company and the Service Provider use reasonable efforts to prevent loss, misuse, or alteration of the Photographs and Images, no method of storage or transmission over the Internet is completely secure, so the use of Harry Potter - The Exhibition is at Users’ own risk."
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "閣下明白收集圖像的目的是為了讓使用者可以即時於場地內購買照片，並在活動期間（直至 2025 年 1 月 5 日）保存在美國的伺服器中，之後它們將自動刪除。 「本公司」及「服務提供者」採取適當安全措施，以保護所收集的照片及圖像免遭任何未經授權的存取及披露，並且只有「本公司」或「服務提供者」的授權員工限於允許的業務功能並透過使用有效的使用者名稱及密碼才能存取這些照片及圖像。 儘管「本公司」及「服務提供者」合理努力防止照片及圖像遺失、被濫用或被篡改，網路上沒有任何儲存或傳輸方式是完全安全的，因此使用 \"哈利-波特--展覽 \"的風險由使用者自行承擔。"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "阁下明白收集图像的目的是为了让使用者可以即时于场地内购买照片，并在活动期间（直至 2025 年 1 月 5 日）保存在美国的伺服器中，之后它们将自动删除。「本公司」及「服务提供者」采取适当安全措施，以保护所收集的照片及图像免遭任何未经授权的存取及披露，并且只有「本公司」或「服务提供者」的授权员工限于允许的业务功能并透过使用有效的使用者名称及密码才能存取这些照片及图像。尽管「本公司」及「服务提供者」合理努力防止照片及图像遗失、被滥用或被篡改，网路上没有任何储存或传输方式是完全安全的，因此使用\"哈利-波特--展览\"的风险由使用者自行承担。"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "You release, discharge, and agree to hold harmless and defend the Company, the Service Provider, their legal representatives or assignees, and all persons acting under their permission or authority, from any liability by virtue of any reason in connection with the making, collection, processing and storage of the Photographs and Images, including without limitation any claims for libel or violation of any right of image, publicity or privacy."
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "閣下免除、解除並同意「本公司」、「服務提供者」、其法定代表或代理人以及在其許可或授權下執行事務的所有人員免於承擔因任何原因而與照片及圖像的製作、收集、處理及儲存有關的任何責任，包括但不限於任何誹謗或侵犯任何肖像權、公開權或隱私權的索賠。"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "阁下免除、解除并同意「本公司」、「服务提供者」、其法定代表或代理人以及在其许可或授权下执行事务的所有人员免于承担因任何原因而与照片及图像的制作、收集、处理及储存有关的任何责任，包括但不限于任何诽谤或侵犯任何肖像权、公开权或隐私权的索赔。"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "The use of Harry Potter - The Exhibition is governed by the laws of the MSAR and any disputes, claims or differences arising out of or in connection with such use shall be submitted to the Courts of the MSAR."
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "《哈利波特 - 展覽》的使用受澳門特別行政區法律管轄，任何因使用而產生或與之相關的爭議、索賠或分歧均應提交澳門特別行政區法院處理。"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "《哈利波特 - 展览》的使用受澳门特别行政区法律管辖，任何因使用而产生或与之相关的争议、索赔或分歧均应提交澳门特别行政区法院处理。"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "For requests related with the collection and storage of Photographs and Images please contact the Company through the email address privacy@sands.com.mo. The Company reserves the right to determine whether your request meets legal regulatory requirements and if it can be addressed."
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "就有關收集及儲存照片及圖像的請求，請透過電子郵件方式privacy@sands.com.mo與「本公司」聯絡。 「本公司」保留權利以確定閣下的請求是否符合法律法規要求以及是否可以進行處理。"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "就有关收集及储存照片及图像的请求，请透过电子邮件方式privacy@sands.com.mo与「本公司」联络。「本公司」保留权利以确定阁下的请求是否符合法律法规要求以及是否可以进行处理。"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "This Consent has been translated into Chinese. If there is any inconsistency or ambiguity between the English version and the Chinese version, the English version shall prevail."
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "本同意書已翻譯成中文。 如果英文版本與中文版本之間存在任何不一致或歧義，以英文版本為準。"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "本同意书已翻译成中文。如果英文版本与中文版本之间存在任何不一致或歧义，以英文版本为准。"
    }
  ],
  "kiosk_approval_form_header": [
    {
      "type": 0,
      "value": "Je potřeba schválení"
    }
  ],
  "kiosk_approval_form_instructions": [
    {
      "type": 0,
      "value": "Vyžádejte si pomoc"
    }
  ],
  "kiosk_attendant_form_header": [
    {
      "type": 0,
      "value": "Schválit nákup"
    }
  ],
  "kiosk_attendant_form_instructions": [
    {
      "type": 0,
      "value": "Zadejte cenu tohoto nákupu."
    }
  ],
  "kiosk_auto_logout_subtitle": [
    {
      "type": 0,
      "value": "Za "
    },
    {
      "offset": 0,
      "options": {
        "few": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " sekundy"
            }
          ]
        },
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " sekundu"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " sekund"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "count"
    },
    {
      "type": 0,
      "value": " budete automaticky odhlášeni"
    }
  ],
  "kiosk_auto_logout_title": [
    {
      "type": 0,
      "value": "Jste tam ještě?"
    }
  ],
  "kiosk_cart_count_verbose": [
    {
      "offset": 0,
      "options": {
        "few": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " digitání snímky"
            }
          ]
        },
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " digitání snímek"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " digitáních snímů"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "imageCount"
    },
    {
      "type": 0,
      "value": ", "
    },
    {
      "offset": 0,
      "options": {
        "few": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " výtisky"
            }
          ]
        },
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " výtisk"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " výtisků"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "printCount"
    }
  ],
  "kiosk_cart_header": [
    {
      "type": 0,
      "value": "Zkontrolovat a koupit"
    }
  ],
  "kiosk_cart_instructions": [
    {
      "type": 0,
      "value": "Klepnutím na "
    },
    {
      "children": [
      ],
      "type": 8,
      "value": "CloseIcon"
    },
    {
      "type": 0,
      "value": " odeberete fotku z košíku. Pokračujte klepnutím na "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "DOKONČIT NÁKUP"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "kiosk_catalog_header": [
    {
      "type": 0,
      "value": "Přidat fotky do galerie"
    }
  ],
  "kiosk_catalog_header_no_gallery": [
    {
      "type": 0,
      "value": "Vyberte fotky, které si chcete zakoupit"
    }
  ],
  "kiosk_catalog_instructions": [
    {
      "type": 0,
      "value": "Klepnutím na fotky je přidáte do galerie. Klepnutím na "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "ZOBRAZIT MOJI GALERII"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " se vrátíte do své galerie."
    }
  ],
  "kiosk_catalog_instructions_no_gallery": [
    {
      "type": 0,
      "value": "Klepnutím na fotky je přidáte do objednávky. Pokračujte klepnutím na "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "ZKONTROLOVAT A KOUPIT"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "kiosk_catalog_loading_message": [
    {
      "type": 0,
      "value": "Načítám fotky…"
    }
  ],
  "kiosk_edit_moment_adjust_subject": [
    {
      "type": 0,
      "value": "Upravit objekt"
    }
  ],
  "kiosk_edit_moment_apply_changes": [
    {
      "type": 0,
      "value": "Použít změny"
    }
  ],
  "kiosk_edit_moment_apply_overlay": [
    {
      "type": 0,
      "value": "Použít překryvnou vrstvu"
    }
  ],
  "kiosk_edit_moment_back": [
    {
      "type": 0,
      "value": "Zpět"
    }
  ],
  "kiosk_edit_moment_close_confirmation": [
    {
      "type": 0,
      "value": "Všechny provedené změny budou zahozeny. Opravdu chcete pokračovat?"
    }
  ],
  "kiosk_edit_moment_complete_edit": [
    {
      "type": 0,
      "value": "Dokončit úpravy"
    }
  ],
  "kiosk_edit_moment_crop_image": [
    {
      "type": 0,
      "value": "Oříznout fotku"
    }
  ],
  "kiosk_edit_moment_done": [
    {
      "type": 0,
      "value": "Hotovo"
    }
  ],
  "kiosk_edit_moment_next": [
    {
      "type": 0,
      "value": "Další"
    }
  ],
  "kiosk_enter_access_code": [
    {
      "type": 0,
      "value": "Zadejte přístupový kód"
    }
  ],
  "kiosk_gallery_header": [
    {
      "type": 0,
      "value": "Vybrat a koupit"
    }
  ],
  "kiosk_gallery_header_clubmed": [
    {
      "type": 0,
      "value": "Galerie vašich fotek"
    }
  ],
  "kiosk_gallery_header_pre_print": [
    {
      "type": 0,
      "value": "Vybrat a vytisknout"
    }
  ],
  "kiosk_gallery_header_unlocked": [
    {
      "type": 0,
      "value": "Galerie vašich fotek"
    }
  ],
  "kiosk_gallery_instructions": [
    {
      "type": 0,
      "value": "Klepnutím na obrázek jej vyberte k nákupu. Klepnutím na "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "buttonLabel"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " pokračujte."
    }
  ],
  "kiosk_gallery_instructions_empty_gallery": [
    {
      "type": 0,
      "value": "Vaše galerie je prázdná. Klepnutím na možnost "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "DALŠÍ FOTKY"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " v pravém horním rohu obrazovky si zobrazíte dostupné fotky."
    }
  ],
  "kiosk_gallery_instructions_pre_print": [
    {
      "type": 0,
      "value": "Klepnutím na ikonu tisku u fotky ji vyberte pro tisk. Klepnutím na tlačítko Tisk vybrané fotky stáhnete."
    }
  ],
  "kiosk_gallery_instructions_prints": [
    {
      "type": 0,
      "value": "Klepnutím na obrázek jej vyberte k nákupu. Poklepáním požádejte o tisk. Klepnutím na "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "buttonLabel"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " pokračujte."
    }
  ],
  "kiosk_gallery_instructions_unlocked": [
    {
      "type": 0,
      "value": "Odemkli jste všechny fotky. Klepnutím na "
    },
    {
      "children": [
      ],
      "type": 8,
      "value": "CloseIcon"
    },
    {
      "type": 0,
      "value": " je odeberete z galerie."
    }
  ],
  "kiosk_gallery_instructions_unlocked_prints": [
    {
      "type": 0,
      "value": "Odemkli jste všechny fotky. Klepnutím na fotku můžete požádat o výtisk. Klepnutím na "
    },
    {
      "children": [
      ],
      "type": 8,
      "value": "CloseIcon"
    },
    {
      "type": 0,
      "value": " je odeberete z galerie."
    }
  ],
  "kiosk_image_tooltip_add_print": [
    {
      "type": 0,
      "value": "Přidat výtisk"
    }
  ],
  "kiosk_image_tooltip_digital_purchased": [
    {
      "type": 0,
      "value": "Digitální snímek zakoupen"
    }
  ],
  "kiosk_image_tooltip_print_purchased": [
    {
      "type": 0,
      "value": "Výtisk zakoupen"
    }
  ],
  "kiosk_image_tooltip_print_selected": [
    {
      "type": 0,
      "value": "Vytisknout vybrané"
    }
  ],
  "kiosk_image_tooltip_remove_print": [
    {
      "type": 0,
      "value": "Odebrat tisk"
    }
  ],
  "kiosk_image_tooltip_select_print": [
    {
      "type": 0,
      "value": "Vybrat tisk"
    }
  ],
  "kiosk_images_header": [
    {
      "type": 0,
      "value": "Vaše fotky"
    }
  ],
  "kiosk_images_header_clubmed": [
    {
      "type": 0,
      "value": "Vybrat fotky"
    }
  ],
  "kiosk_images_header_selected": [
    {
      "type": 0,
      "value": "Váš výběr"
    }
  ],
  "kiosk_login_header_access_your_images": [
    {
      "type": 0,
      "value": "Přístup k vašim fotkám"
    }
  ],
  "kiosk_login_header_clubmed": [
    {
      "type": 0,
      "value": "Zadejte číslo svého pokoje, příjmení a e-mail, abyste získali přístup do galerie"
    }
  ],
  "kiosk_login_header_preprint": [
    {
      "type": 0,
      "value": "Galerie před tiskem"
    }
  ],
  "kiosk_login_header_welcome": [
    {
      "type": 0,
      "value": "Vítejte!"
    }
  ],
  "kiosk_login_hpx_footer_text": [
    {
      "type": 0,
      "value": "KOUZELNICKÝ SVĚT a všechny související ochranné známky, znaky, jména a odkazy jsou © & ™ Warner Bros. Entertainment Inc. Publishing Rights © JKR. (s22)"
    }
  ],
  "kiosk_login_instructions_enter_email": [
    {
      "type": 0,
      "value": "Pokračujte zadáním e-mailové adresy."
    }
  ],
  "kiosk_login_instructions_scan_band": [
    {
      "type": 0,
      "value": "Začněte naskenováním náramku"
    }
  ],
  "kiosk_offsite_pos_form_bill_to_room_header": [
    {
      "type": 0,
      "value": "Účtovat na pokoj"
    }
  ],
  "kiosk_offsite_pos_form_bill_to_room_instructions": [
    {
      "type": 0,
      "value": "Uvedená celková částka bude účtována přímo na váš pokoj"
    }
  ],
  "kiosk_offsite_pos_form_generic_header": [
    {
      "type": 0,
      "value": "Dokončit nákup"
    }
  ],
  "kiosk_offsite_pos_form_generic_instructions": [
    {
      "type": 0,
      "value": "Vaše objednávka obsahuje:"
    }
  ],
  "kiosk_order_details_disclaimer_no_refunds": [
    {
      "type": 0,
      "value": "* Všechny prodeje jsou konečné a vrácení peněz není možné."
    }
  ],
  "kiosk_order_details_header": [
    {
      "type": 0,
      "value": "Podrobnosti objednávky"
    }
  ],
  "kiosk_order_details_instructions": [
    {
      "type": 0,
      "value": "Klepnutím na fotky vlevo je vyberte k nákupu."
    }
  ],
  "kiosk_order_details_instructions_cart_empty": [
    {
      "type": 0,
      "value": "Váš nákupní košík je prázdný. Klepnutím na fotky je přidáte do objednávky."
    }
  ],
  "kiosk_order_details_instructions_cart_empty_more_images": [
    {
      "type": 0,
      "value": "Váš nákupní košík je prázdný. Další fotky přidáte klepnutím na "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "PŘIDAT DALŠÍ FOTKY"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "kiosk_order_details_instructions_email": [
    {
      "type": 0,
      "value": "Fotky obdržíte e-mailem"
    }
  ],
  "kiosk_order_details_instructions_prints": [
    {
      "type": 0,
      "value": "Poklepáním na fotku si můžete vyžádat tisk."
    }
  ],
  "kiosk_payment_method_form_header": [
    {
      "type": 0,
      "value": "Dokončit nákup"
    }
  ],
  "kiosk_payment_method_form_instructions": [
    {
      "type": 0,
      "value": "Jak chcete dokončit nákup?"
    }
  ],
  "kiosk_price_guide_header": [
    {
      "type": 0,
      "value": "Průvodce cenami"
    }
  ],
  "kiosk_price_guide_instructions": [
    {
      "type": 0,
      "value": "Nakupte víc fotek a získejte slevu"
    }
  ],
  "kiosk_price_guide_instructions_standard_price": [
    {
      "type": 0,
      "value": "Standardní cena je "
    },
    {
      "type": 1,
      "value": "price"
    },
    {
      "type": 0,
      "value": " za fotku"
    }
  ],
  "kiosk_price_guide_instructions_unlocked": [
    {
      "type": 0,
      "value": "Můžete přidat další fotky zdarma"
    }
  ],
  "kiosk_print_size_edits_cancel": [
    {
      "type": 0,
      "value": "Zrušit"
    }
  ],
  "kiosk_print_size_edits_continue": [
    {
      "type": 0,
      "value": "Pokračovat"
    }
  ],
  "kiosk_print_size_edits_create": [
    {
      "type": 0,
      "value": "Vytvořit"
    }
  ],
  "kiosk_print_size_select_header": [
    {
      "type": 0,
      "value": "Velikosti tisku"
    }
  ],
  "kiosk_print_size_select_instructions": [
    {
      "type": 0,
      "value": "Vyberte velikost(i) tisku a množství"
    }
  ],
  "kiosk_processing_edited_moment": [
    {
      "type": 0,
      "value": "Zpracováváme upravenou fotku…"
    }
  ],
  "kiosk_processing_payment": [
    {
      "type": 0,
      "value": "Zpracováváme platbu…"
    }
  ],
  "kiosk_purchase_details_discounts_offered": [
    {
      "children": [
        {
          "type": 0,
          "value": "Nabízené slevy:"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "kiosk_purchase_details_packages_offered": [
    {
      "children": [
        {
          "type": 0,
          "value": "Nabízené balíčky:"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "kiosk_purchase_details_per_image": [
    {
      "type": 1,
      "value": "price"
    },
    {
      "type": 0,
      "value": " za fotku"
    }
  ],
  "kiosk_purchase_details_standard_price": [
    {
      "children": [
        {
          "type": 0,
          "value": "Standardní cena:"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "kiosk_purchase_details_total": [
    {
      "children": [
        {
          "type": 0,
          "value": "Celkem:"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "kiosk_purchase_disabled_instructions": [
    {
      "type": 0,
      "value": "Klepnutím na fotky je přidáte do objednávky"
    }
  ],
  "kiosk_purchase_disabled_instructions_more_images": [
    {
      "type": 0,
      "value": "Klepnutím na fotky je vyberte nebo zrušíte jejich výběr pro nákup. Další fotky z výběru přidáte klepnutím na "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "DALŠÍ FOTKY"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "kiosk_reader_not_connected": [
    {
      "type": 0,
      "value": "Čtečka není připojená"
    }
  ],
  "kiosk_reader_payment_failed": [
    {
      "type": 0,
      "value": "Čtečce se nepodařilo zpracovat platbu"
    }
  ],
  "kiosk_reader_standby": [
    {
      "type": 0,
      "value": "Čtečka v pohotovostním režimu…"
    }
  ],
  "kiosk_receipt_header": [
    {
      "type": 0,
      "value": "Nákup dokončen"
    }
  ],
  "kiosk_receipt_instructions": [
    {
      "type": 0,
      "value": "Odkaz na vaši galerii byl odeslán na adresu "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "email"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "kiosk_remove_modal_instructions": [
    {
      "type": 0,
      "value": "Chcete tuto fotku z objednávky odebrat? Budete ji muset najít znovu klepnutím na "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "PŘIDAT DALŠÍ FOTKY"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "kiosk_room_dialog_header": [
    {
      "type": 0,
      "value": "Místnost "
    },
    {
      "type": 1,
      "value": "room"
    }
  ],
  "kiosk_room_dialog_header_multiple": [
    {
      "type": 0,
      "value": "Pokoje "
    },
    {
      "type": 1,
      "value": "rooms"
    }
  ],
  "kiosk_room_dialog_instructions_link_sent": [
    {
      "type": 0,
      "value": "E-mailem byl zaslán odkaz na adresu "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "email"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "kiosk_search_images": [
    {
      "type": 0,
      "value": "Vyhledat fotky"
    }
  ],
  "kiosk_selected_print_size": [
    {
      "type": 0,
      "value": "Velikost tisku"
    }
  ],
  "kiosk_selected_print_sizes_aspect_column": [
    {
      "type": 0,
      "value": "Poměr stran"
    }
  ],
  "kiosk_selected_print_sizes_header": [
    {
      "type": 0,
      "value": "Vybrané výtisky"
    }
  ],
  "kiosk_selected_print_sizes_photo_column": [
    {
      "type": 0,
      "value": "Okamžik"
    }
  ],
  "kiosk_selected_print_sizes_quantity_column": [
    {
      "type": 0,
      "value": "Množství"
    }
  ],
  "kiosk_selected_print_sizes_size_column": [
    {
      "type": 0,
      "value": "Velikost tisku"
    }
  ],
  "kiosk_stripe_form_header": [
    {
      "type": 0,
      "value": "Dokončit nákup"
    }
  ],
  "kiosk_stripe_form_header_clubmed": [
    {
      "type": 0,
      "value": "Zadejte platební údaje"
    }
  ],
  "kiosk_topbar_welcome_message": [
    {
      "type": 0,
      "value": "Vítejte, "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "name"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "!"
    }
  ],
  "kiosk_welcome_message": [
    {
      "type": 0,
      "value": "Vítejte, "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "name"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "!"
    }
  ]
}